<h2 class="mat-h2">Sales</h2>
<table>
  <tr>
    <th></th>
    <th>Total #</th>
    <th [matTooltip]="momentumShortDesc">Δ 4 month</th>
    <th [matTooltip]="momentumLongDesc">Δ PY</th>
    <!-- <th>Budget</th> -->
    <!-- <th>%</th> -->
  </tr>
  <ng-container *ngIf="salesInPack; else salesInPackNoData">
    <tr>
      <td>National # pack</td>
      <td class="center">{{ salesInPack.national.salesTotal }}</td>
      <td class="center">{{ salesInPack.national.salesFourMonth }}</td>
      <td class="center">{{ salesInPack.national.salesPy }}</td>
      <!-- <td class="center">{{ salesInPack.national.salesBudget }}</td> -->
      <!-- <td class="center">{{ salesInPack.national.salesPercent }}</td> -->
    </tr>
    <tr>
      <td>National €</td>
      <td class="center">{{ salesInPack.national.salesInEuroTotal }}</td>
      <td class="center">{{ salesInPack.national.salesInEuroFourMonth }}</td>
      <td class="center">{{ salesInPack.national.salesInEuroPy }}</td>
      <!-- <td class="center">{{ salesInPack.national.salesInEuroBudget }}</td> -->
      <!-- <td class="center">{{ salesInPack.national.salesInEuroPercent }}</td> -->
    </tr>

    <!-- <ng-container *ngFor="let competitor of salesInPack.competitors; let i = index">
      <tr>
        <td>National {{ competitor.name }} # pack</td>
        <td class="center">{{ competitor.salesNationalTotal }}</td>
        <td class="center">{{ competitor.salesNationalFourMonth }}</td>
        <td class="center">{{ competitor.salesNationalPy }}</td>
      </tr>
      <tr>
        <td>National {{ competitor.name }} €</td>
        <td class="center">{{ competitor.salesInEuroNationalTotal }}</td>
        <td class="center">{{ competitor.salesInEuroNationalFourMonth }}</td>
        <td class="center">{{ competitor.salesInEuroNationalPy }}</td>
      </tr>
    </ng-container> -->


    <tr>
      <td>Territory # pack</td>
      <td class="center">{{ salesInPack.territory.salesTotal }}</td>
      <td class="center">{{ salesInPack.territory.salesFourMonth }}</td>
      <td class="center">{{ salesInPack.territory.salesPy }}</td>
      <!-- <td class="center">{{ salesInPack.territory.salesBudget }}</td> -->
      <!-- <td class="center">{{ salesInPack.territory.salesPercent }}</td> -->
    </tr>
    <tr>
      <td>Territory €</td>
      <td class="center">{{ salesInPack.territory.salesInEuroTotal }}</td>
      <td class="center">{{ salesInPack.territory.salesInEuroFourMonth }}</td>
      <td class="center">{{ salesInPack.territory.salesInEuroPy }}</td>
      <!-- <td class="center">{{ salesInPack.territory.salesInEuroBudget }}</td> -->
      <!-- <td class="center">{{ salesInPack.territory.salesInEuroPercent }}</td> -->
    </tr>

    <!-- <ng-container *ngFor="let competitor of salesInPack.competitors; let i = index">
      <tr>
        <td>Territory {{ competitor.name }} # pack</td>
        <td class="center">{{ competitor.salesTerritoryTotal }}</td>
        <td class="center">{{ competitor.salesTerritoryFourMonth }}</td>
        <td class="center">{{ competitor.salesTerritoryPy }}</td>
      </tr>
      <tr>
        <td>Territory {{ competitor.name }} €</td>
        <td class="center">{{ competitor.salesInEuroTerritoryTotal }}</td>
        <td class="center">{{ competitor.salesInEuroTerritoryFourMonth }}</td>
        <td class="center">{{ competitor.salesInEuroTerritoryPy }}</td>
      </tr>
    </ng-container> -->

  </ng-container>
  <ng-template #salesInPackNoData>
    <tr>
      <td colspan="6" class="center">No data available</td>
    </tr>
  </ng-template>
</table>
